import './DeckBuild.scss';
const DeckBuild = () => {
  return (
    <div>
      <h1>Coming Soon</h1>
    </div>
  );
};

export default DeckBuild;
